import { HTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface Props extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
}

export function Root({ children, ...rest }: Props) {
    return (
        <div className={twMerge("tw-w-full tw-mt-8", rest.className)} {...rest}>
            {children}
        </div>
    )
}